<template>
  <div>
    <b-form-radio-group v-model="formPatientInsurances.billTypes">
      <b-form-radio
        @change="changeBillTypes"
        v-for="(option, index) in billTypes"
        :key="index"
        :value="index"
        class="mr-5"
        :disabled="index == 0 && disabled"
        >{{ option }}
      </b-form-radio>
    </b-form-radio-group>
    <b-card v-show="formPatientInsurances.billTypes == 0">
      <b-form-group label="Primary" v-show="showInsurancePrimary">
        <v-select
          :options="insurancesOptions"
          v-model="formPatientInsurances.insurancePrimary"
        />
      </b-form-group>
      <b-form-group label="Secondary" v-show="showInsuranceSecundary">
        <v-select
          :options="insurancesOptions"
          v-model="formPatientInsurances.insuranceSecundary"
        />
      </b-form-group>
      <b-form-group label="Tertiary" v-show="showInsuranceTertiary">
        <v-select
          :options="insurancesOptions"
          v-model="formPatientInsurances.insuranceTertiary"
        />
      </b-form-group>
    </b-card>
  </div>
</template>
<script>
export default {
  name: "PatientInsurances",
  props: ["insurances", "eocBillType", "eocInsurances"],
  data() {
    return {
      insurancesOptions: [],
      formPatientInsurances: {
        insurancePrimary: { label: "None", value: null },
        insuranceSecundary: { label: "None", value: null },
        insuranceTertiary: { label: "None", value: null },
        billTypes: 0
      },
      billTypes: ["Insurance", "Self-Pay"],
      showInsurancePrimary: false,
      showInsuranceSecundary: false,
      showInsuranceTertiary: false,
      disabled: false,
      eocInsurancesValue: null,
      isSelfPay: false
    };
  },
  mounted() {
    this.eocInsurancesValue = this.eocInsurances;
    this.isSelfPay = this.eocBillType == 0;
    this.initialize();
    setTimeout(() => {
      this.$emit("setIsSelfPay", this.isSelfPay);
    }, 0);
  },
  methods: {
    initialize() {
      if (this.insurances?.length > 0) {
        this.insurancesOptions = this.insurances.map(e => ({
          label: e.company.name,
          value: e.id,
          data: e
        }));
      }
      this.insurancesOptions.push({ label: "None", value: null });

      if (this.eocInsurancesValue?.id) {
        if (
          this.eocInsurancesValue?.insurancePrimary ||
          this.eocInsurancesValue?.insuranceSecundary ||
          this.eocInsurancesValue?.insuranceTertiary
        ) {
          this.formPatientInsurances.insurancePrimary = {
            label:
              this.eocInsurancesValue?.insurancePrimary?.company?.name ??
              "None",
            value: this.eocInsurancesValue?.insurancePrimary?.id,
            data: this.eocInsurancesValue?.insurancePrimary
          };
          this.formPatientInsurances.insuranceSecundary = {
            label:
              this.eocInsurancesValue?.insuranceSecundary?.company?.name ??
              "None",
            value: this.eocInsurancesValue?.insuranceSecundary?.id,
            data: this.eocInsurancesValue?.insuranceSecundary
          };
          this.formPatientInsurances.insuranceTertiary = {
            label:
              this.eocInsurancesValue?.insuranceTertiary?.company?.name ??
              "None",
            value: this.eocInsurancesValue?.insuranceTertiary?.id,
            data: this.eocInsurancesValue?.insuranceTertiary
          };
          if (
            this.formPatientInsurances.insurancePrimary?.value ||
            this.insurances.length >= 1
          )
            this.showInsurancePrimary = true;
          if (
            this.formPatientInsurances.insuranceSecundary?.value ||
            this.insurances.length >= 2
          )
            this.showInsuranceSecundary = true;
          if (
            this.formPatientInsurances.insuranceTertiary?.value ||
            this.insurances.length >= 3
          )
            this.showInsuranceTertiary = true;
          this.changeToSelfPayOption();
          return;
        } else {
          this.changeToSelfPayOption();
          this.assignNoneToSelectors();
        }
      }
      if (this.formPatientInsurances.billTypes == 0) {
        let primaryInsurances = this.insurancesOptions.filter(
          e => e.data?.primary
        );
        let keys = Object.keys(this.formPatientInsurances);
        for (let i = 0; i < primaryInsurances.length; i++) {
          if (i > 2) break;
          this.$set(this.formPatientInsurances, keys[i], primaryInsurances[i]);
        }
        let secundaryInsurances = this.insurancesOptions.filter(
          e => e.data?.secondary
        );
        for (let i = 0; i < secundaryInsurances.length; i++) {
          if (i > 2) break;
          keys.some(k => {
            if (!this.formPatientInsurances[k]["value"] && k != "billTypes") {
              this.$set(this.formPatientInsurances, k, secundaryInsurances[i]);
              return true;
            }
          });
        }
        let tertiaryInsurances = this.insurancesOptions.filter(
          e => e.data?.tertiary
        );
        for (let i = 0; i < tertiaryInsurances.length; i++) {
          if (i > 2) break;
          keys.some(k => {
            if (!this.formPatientInsurances[k]["value"] && k != "billTypes") {
              this.$set(this.formPatientInsurances, k, tertiaryInsurances[i]);
              return true;
            }
          });
        }
        let otherInsurances = this.insurancesOptions.filter(
          e =>
            !e.data?.primary &&
            !e.data?.secondary &&
            !e.data?.tertiary &&
            e.value
        );
        for (let i = 0; i < otherInsurances.length; i++) {
          if (i > 2) break;
          keys.some(k => {
            if (!this.formPatientInsurances[k]["value"] && k != "billTypes") {
              this.$set(this.formPatientInsurances, k, otherInsurances[i]);
              return true;
            }
          });
        }
        if (this.formPatientInsurances.insurancePrimary.value)
          this.showInsurancePrimary = true;
        if (this.formPatientInsurances.insuranceSecundary.value)
          this.showInsuranceSecundary = true;
        if (this.formPatientInsurances.insuranceTertiary.value)
          this.showInsuranceTertiary = true;
        this.changeToSelfPayOption();
      }
    },
    assignNoneToSelectors() {
      this.formPatientInsurances.insurancePrimary = {
        label: "None",
        value: null
      };
      this.formPatientInsurances.insuranceSecundary = {
        label: "None",
        value: null
      };
      this.formPatientInsurances.insuranceTertiary = {
        label: "None",
        value: null
      };
    },
    changeToSelfPayOption() {
      if (
        (!this.formPatientInsurances.insurancePrimary.value &&
          !this.formPatientInsurances.insuranceSecundary.value &&
          !this.formPatientInsurances.insuranceTertiary.value) ||
        (this.isSelfPay && !this.eocInsurancesValue)
      ) {
        this.formPatientInsurances.billTypes = 1;
        if (this.isSelfPay) this.assignNoneToSelectors();

        if (!this.insurancesOptions.length > 0) {
          this.disabled = true;
        }
        if (this.eocInsurancesValue) this.eocInsurancesValue = null;
      }
      if (this.isSelfPay) this.isSelfPay = false;
    },
    changeBillTypes() {
      if (this.insurances.length > 0) {
        if (this.formPatientInsurances.billTypes == 1)
          this.assignNoneToSelectors();
        else {
          this.initialize();
        }
      } else {
        this.changeToSelfPayOption();
      }
    }
  },
  watch: {
    insurances: function(newVal, oldValue) {
      if (newVal != oldValue) {
        this.formPatientInsurances.billTypes = 0;
        this.insurancesOptions = [];
        this.assignNoneToSelectors();
        if (this.showInsurancePrimary) this.showInsurancePrimary = false;
        if (this.showInsuranceSecundary) this.showInsuranceSecundary = false;
        if (this.showInsuranceTertiary) this.showInsuranceTertiary = false;
        this.eocInsurancesValue = this.eocInsurances;
        this.isSelfPay = this.eocBillType == 0;
      }
      this.initialize();
    },
    "formPatientInsurances.insurancePrimary": function(newVal, oldValue) {
      if (newVal) {
        if (
          newVal.value != oldValue?.value &&
          this.formPatientInsurances.billTypes == 0
        ) {
          if (newVal.value)
            for (let key in this.formPatientInsurances) {
              if (
                this.formPatientInsurances[key]["value"] == newVal.value &&
                key != "insurancePrimary" &&
                key != "billTypes"
              ) {
                this.$set(this.formPatientInsurances, key, oldValue);
                break;
              }
            }

          if (!newVal.value) this.changeToSelfPayOption();
        }
      } else {
        this.formPatientInsurances.insurancePrimary = {
          label: "None",
          value: null
        };
        this.changeToSelfPayOption();
      }
      this.$emit("formPatientInsurancesData", this.formPatientInsurances);
    },
    "formPatientInsurances.insuranceSecundary": function(newVal, oldValue) {
      if (newVal) {
        if (
          newVal.value != oldValue?.value &&
          this.formPatientInsurances.billTypes == 0
        ) {
          if (newVal.value)
            for (let key in this.formPatientInsurances) {
              if (
                this.formPatientInsurances[key]["value"] == newVal.value &&
                key != "insuranceSecundary" &&
                key != "billTypes"
              ) {
                this.$set(this.formPatientInsurances, key, oldValue);
                break;
              }
            }
          if (!newVal.value) this.changeToSelfPayOption();
        }
      } else {
        this.formPatientInsurances.insuranceSecundary = {
          label: "None",
          value: null
        };
        this.changeToSelfPayOption();
      }
      this.$emit("formPatientInsurancesData", this.formPatientInsurances);
    },
    "formPatientInsurances.insuranceTertiary": function(newVal, oldValue) {
      if (newVal) {
        if (
          newVal.value != oldValue?.value &&
          this.formPatientInsurances.billTypes == 0
        ) {
          if (newVal.value)
            for (let key in this.formPatientInsurances) {
              if (
                this.formPatientInsurances[key]["value"] == newVal.value &&
                key != "insuranceTertiary" &&
                key != "billTypes"
              ) {
                this.$set(this.formPatientInsurances, key, oldValue);
                break;
              }
            }
          if (!newVal.value) this.changeToSelfPayOption();
        }
      } else {
        this.formPatientInsurances.insuranceTertiary = {
          label: "None",
          value: null
        };
        this.changeToSelfPayOption();
      }
      this.$emit("formPatientInsurancesData", this.formPatientInsurances);
    },
    "formPatientInsurances.billTypes": function(newVal, oldValue) {
      if (newVal != oldValue) {
        this.isSelfPay = newVal == 1;
        this.$emit("setIsSelfPay", this.isSelfPay);
        this.$emit("costVariations");
      }
    }
  }
};
</script>
